import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IUnitCustomZoneModel } from '@apps-common/types/portal/unit'

export const createSiteZone = async (model: IUnitCustomZoneModel): Promise<IUnitCustomZoneModel> =>
  axios.post(`/my-monitoring/sites/AddZone`, model).then((res) => res?.data?.data)

type Props = {
  model: IUnitCustomZoneModel
}

export const useMyMonitoringCreateSiteZone = (notify?: boolean, onSuccess?: (data: IUnitCustomZoneModel) => void) =>
  useMutation({
    mutationKey: ['createMyMonitoringSiteZone'],
    mutationFn: ({ model }: Props) => createSiteZone(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Created zone.')
      }
    },
    onError: (error) => {
      if (notify) {
        toastError(error?.message || 'Failed to create zone, please try again.')
      }
    },
    throwOnError: false
  })
